import React, { useState } from "react";
import "./Testimonials.css";
import Testimonial from "../Testimonial/Testimonial";

const Testimonials = () => {
  const [testimonialData, setTestimonialData] = useState([]);
  fetch("https://polar-bayou-98466.herokuapp.com/reviews")
    .then((res) => res.json())
    .then((data) => setTestimonialData(data));
  return (
    <section id="reviews" className="text-white testimonials-section">
      <p className="h2 brand-logo text-center mb-4">
        WHAT <span className="main-text">CUSTOMERS</span> ARE SAYING
      </p>
      <div className="row m-0 justify-content-center">
        {testimonialData.map((testimonial) => (
          <Testimonial testimonial={testimonial} key={testimonial.name} />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
